import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let ExplainCanvassStatus = {
    selector: "vcExplainCanvassStatus",
    templateUrl:
        "/angular/components/canvass-status/explain-canvass-status.component.html",
    bindings: {},
    controller: class ExplainCanvassStatusController {
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        close(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("canvassStatus")
    .component(ExplainCanvassStatus.selector, ExplainCanvassStatus);
